const data = [
  { date: '2013', 'Subscriber count': 6317 },
  { date: '2014', 'Subscriber count': 8247 },
  { date: '2015', 'Subscriber count': 9759 },
  { date: '2016', 'Subscriber count': 11309 },
  { date: '2017', 'Subscriber count': 14260 },
  { date: '2018', 'Subscriber count': 19358 },
  { date: '2019', 'Subscriber count': 30894 },
  { date: '2020', 'Subscriber count': 51412 },
  { date: '2021', 'Subscriber count': 99611 },
  { date: '2022', 'Subscriber count': 120462 },
];

export default data;
